module.exports = __webpack_public_path__ + "img/yujinhui_20210901114500.2307bc85.png";